import { db } from '../firebase-config';
import { collection, getDocs, getDoc, doc, addDoc, updateDoc, deleteDoc } from 'firebase/firestore';

// Get all plugins from Firestore
export const getPlugins = async () => {
  try {
    const pluginsCollection = collection(db, 'plugins');
    const pluginSnapshot = await getDocs(pluginsCollection);
    const pluginsList = pluginSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    
    console.log(`✅ Retrieved ${pluginsList.length} plugins from Firestore`);
    return pluginsList;
  } catch (error) {
    console.error('❌ Error fetching plugins from Firestore:', error);
    throw error;
  }
};

// Get a single plugin by ID
export const getPluginById = async (pluginId) => {
  try {
    const pluginDoc = doc(db, 'plugins', pluginId);
    const pluginSnapshot = await getDoc(pluginDoc);
    
    if (pluginSnapshot.exists()) {
      const pluginData = {
        id: pluginSnapshot.id,
        ...pluginSnapshot.data()
      };
      console.log(`✅ Retrieved plugin: ${pluginData.name}`);
      return pluginData;
    } else {
      throw new Error('Plugin not found');
    }
  } catch (error) {
    console.error('❌ Error fetching plugin:', error);
    throw error;
  }
};

// Create a new plugin
export const createPlugin = async (pluginData) => {
  try {
    const pluginsCollection = collection(db, 'plugins');
    const docRef = await addDoc(pluginsCollection, {
      ...pluginData,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      project: 'transfer-e077b'
    });
    
    console.log(`✅ Plugin created with ID: ${docRef.id}`);
    return { id: docRef.id, ...pluginData };
  } catch (error) {
    console.error('❌ Error creating plugin:', error);
    throw error;
  }
};

// Update a plugin
export const updatePlugin = async (pluginId, pluginData) => {
  try {
    const pluginDoc = doc(db, 'plugins', pluginId);
    await updateDoc(pluginDoc, {
      ...pluginData,
      updated_at: new Date().toISOString()
    });
    
    console.log(`✅ Plugin updated: ${pluginId}`);
  } catch (error) {
    console.error('❌ Error updating plugin:', error);
    throw error;
  }
};

// Delete a plugin
export const deletePlugin = async (pluginId) => {
  try {
    const pluginDoc = doc(db, 'plugins', pluginId);
    await deleteDoc(pluginDoc);
    
    console.log(`✅ Plugin deleted: ${pluginId}`);
  } catch (error) {
    console.error('❌ Error deleting plugin:', error);
    throw error;
  }
};